const initialState = {
  loading: false,
  data: null,
  dhl_error: false,
  aramex_error: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_SHIPPING_LOADING":
      return { ...state, loading: !state.loading };
    case "FETCH_SHIPPING_DATA":
      return { ...state, data: payload };
    case "SET_SHIPPING_ERROR":
      return { ...state, dhl_error: payload };
    case "SET_SHIPPING_ERROR_ARAMEX":
      return { ...state, aramex_error: payload };
    default:
      return state;
  }
};
